import PropTypes from 'prop-types';
import React from 'react';
import { PropTypes as PropTypes$1 } from '@panneau/core';
import Radios from '@panneau/element-radios';

var propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes$1.selectOptions,
  withBackground: PropTypes.bool,
  disabled: PropTypes.bool,
  uncheckable: PropTypes.bool,
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  onChange: PropTypes.func
};
var defaultProps = {
  name: null,
  value: null,
  options: [],
  withBackground: false,
  disabled: false,
  uncheckable: false,
  className: null,
  buttonClassName: null,
  onChange: null
};
var RadiosField = function RadiosField(_ref) {
  var name = _ref.name,
    value = _ref.value,
    options = _ref.options,
    withBackground = _ref.withBackground,
    disabled = _ref.disabled,
    uncheckable = _ref.uncheckable,
    className = _ref.className,
    buttonClassName = _ref.buttonClassName,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(Radios, {
    name: name,
    value: value,
    options: options,
    withBackground: withBackground,
    className: className,
    buttonClassName: buttonClassName,
    onChange: onChange,
    disabled: disabled,
    uncheckable: uncheckable
  });
};
RadiosField.propTypes = propTypes;
RadiosField.defaultProps = defaultProps;

var definition = {
  id: 'radios',
  component: 'Radios'
};

export { RadiosField as default, definition };
